import { isPlatformBrowser } from '@angular/common';
import { Component, inject, PLATFORM_ID } from '@angular/core';

@Component({
    selector: 'app-brake-app-privacy-terms-page',
    templateUrl: './brake-app-privacy-terms-page.component.html',
    styleUrls: ['./brake-app-privacy-terms-page.component.scss'],
    standalone: false
})
export class BrakeAppPrivacyTermsPageComponent {
  platformId = inject(PLATFORM_ID);
  constructor() {
    this.setCustomWidth();
  }
  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
    const widthInPixels = window.innerWidth - 10;
    document.documentElement.style.setProperty('--cx-page-width-max', `${widthInPixels}px`);
  }
}
}
